export default "__VITE_ASSET__CYcwRamn__"